import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'sun_protection'

// Map numeric ratings to meaningful text values
const RATING_VALUES = {
  '1': 'Not Serious',
  '2': 'Somewhat Serious',
  '3': 'Moderately Serious',
  '4': 'Very Serious',
  '5': 'Extremely Serious',
}

export default function SunProtectionPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(RATING_VALUES).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    // Get the corresponding text value
    const textValue = RATING_VALUES[rating as keyof typeof RATING_VALUES]

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How serious are you about sun protection, like sunscreen?',
      answer_key: rating,
      answer: textValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.sunProtection.heading"
      minSubtitle="pages.onboarding.sunProtection.options.rarely"
      maxSubtitle="pages.onboarding.sunProtection.options.always"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
